import { render, staticRenderFns } from "./matching-ribbon.vue?vue&type=template&id=d34444be&scoped=true&"
import script from "./matching-ribbon.vue?vue&type=script&lang=ts&"
export * from "./matching-ribbon.vue?vue&type=script&lang=ts&"
import style0 from "./matching-ribbon.vue?vue&type=style&index=0&id=d34444be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d34444be",
  null
  
)

export default component.exports